import axios from "axios";

/**
 * Axios instance – COOKIE AUTH (Django Session)
 */
const API = axios.create({
  baseURL: "https://auth.teqa.net/auth/",
  withCredentials: true,
});

// CSRF Django
API.defaults.xsrfCookieName = "csrftoken";
API.defaults.xsrfHeaderName = "X-CSRFToken";

/**
 * LOGIN (JSON فقط)
 */
export const login = (data) =>
  API.post("login/", {
    email: data.email,
    password: data.password,
  });

/**
 * GET CURRENT USER
 */
export const getCurrentUser = () =>
  API.get("user/me/");

// REGISTER (multi-step → données combinées)
export const register = (data) => API.post("register/", data);

// CHECK EMAIL
export const checkEmail = (data) => API.post("check-email/", data);

// CHECK USERNAME
export const checkUsername = (data) => API.post("check-username/", data);

// CHECK STORE_NAME
export const checkStoreName = (data) => API.post("check-store-name/", data);

// CHECK AGENCY_NAME
export const checkAgencyeName = (data) => API.post("check-agency-name/", data);

// PASSWORD RESET REQUEST
export const requestPasswordReset = (data) => API.post("password/reset/", data);

// PASSWORD RESET CONFIRM
export const confirmPasswordReset = (data) =>
    API.post("password/reset/confirm/", data);


// UPDATE LANGUAGE
export const updateLanguage = (data) => API.patch("user/language/", data);

// UPDATE PROFILE (general update)
export const updateProfile = (data) => API.patch("user/profile/", data);

// UPDATE THEME (light/dark)
export const updateTheme = (data) => API.patch("user/profile/", data);
    
// Pop-up Livreur Info Modal
export const pop_up_livreur = (data) => API.post("register/delivery/", data);

export default API;
